import { render } from "./App.vue.js?vue&type=template&id=7fcdae38!=!../node_modules/vue-loader/dist/index.js??ruleSet[0]!./App.vue?vue&type=template&id=7fcdae38"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__